import { ref } from 'vue';
import { useUser as swUseUser } from '@shopware/composables';
import type { UseUserReturn } from '@shopware/composables';
import type { ShopwareUser } from '~/types/shopware';

export const useShopwareUser = function (): UseUserReturn {
    const useUserData: UseUserReturn = swUseUser();

    return {
        ...useUserData
    };
};

export const useDetailedUser = () => {
    const detailedUser: Ref<ShopwareUser | null> = ref(null);

    const pending = ref(false);

    const fetchDetailedUser = async () => {
        const { apiClient } = useShopwareContext();

        pending.value = true;
        try {
            const response = await apiClient.invoke('readProfile post /account/customer', {
                body: {
                    associations: {
                        group: {}
                    }
                }
            });

            detailedUser.value = response.data;
        } catch (error) {
            console.error('Error while loading User Data', error);
        } finally {
            pending.value = false;
        }
    };

    return { detailedUser, fetchDetailedUser, pending };
};
